import React from "react";
import {
  Box,
  Paper,
  List,
  ListSubheader,
  ListItem,
  ListItemText,
} from "@mui/material";
import { H9TitleSmall } from "../../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../../../components/StyledComponents/Buttons/AuradineButtons";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useTheme } from "../../../../ThemeContext/ThemeContext.js";

export const SiteDemand = React.memo((props) => {
  const { siteDemandData } = props;
  const { colors } = useTheme();
  console.log("siteDemandData", siteDemandData);
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        padding="0.25rem 0.5rem 0.25rem 1rem"
        alignItems={"center"}
      >
        <H9TitleSmall> Site Demand </H9TitleSmall>
        <StyledIconButton colors={colors}>
          <KeyboardArrowRightIcon
            fontSize="medium"
          />
        </StyledIconButton>
      </Box>
      <>
        <List
          sx={{
            width: "100%",
            backgroundColor: "#EEEDF7",
            borderRadius: "1.5rem",
          }}
        >
          {Object.keys(siteDemandData).length > 0 &&
          siteDemandData.configName !== undefined ? (
            <>
              <ListItem>
                <ListItemText>
                  {siteDemandData?.configName}
                </ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText
                  secondary={siteDemandData?.QSE}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  secondary={
                    siteDemandData?.rampupdown_time
                  }
                />
              </ListItem>
            </>
          ) : (
            <ListItem>
              <ListItemText secondary="Site demand data unavailable" />
            </ListItem>
          )}
        </List>
      </>
    </Box>
  );
});
